// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import { GET_INFO_CUSTOMER_PAYMENT_DONE, GET_LIST_BANK_BRANCH_DONE, GET_LIST_BANK_DONE } from './constant';

export type CustomerPaymentState = {
  listBank: any;
  infoCustomerPayment: any;
  listBankBranch: any;
};

const initState: CustomerPaymentState = {
  listBank: [],
  infoCustomerPayment: [],
  listBankBranch: []
};

const cauHinhDiaChiReducer = (
  state = initState,
  action: ActionType,
): CustomerPaymentState => {
  return produce(
    state,
    (draftState: CustomerPaymentState): CustomerPaymentState => {
      switch (action.type) {
        case GET_INFO_CUSTOMER_PAYMENT_DONE:
          draftState.infoCustomerPayment = action.payload;
          return draftState;
        case GET_LIST_BANK_DONE:
          draftState.listBank = action.payload;
          return draftState;
        case GET_LIST_BANK_BRANCH_DONE:
          draftState.listBankBranch = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};

export default cauHinhDiaChiReducer